import { FC, ReactNode } from 'react';
import translation from '../../languages';
import cn from '../../utils/classnames';
import StarRating from '../star-rating/star-rating';
import './material-rating.scss';

const RatingContainer: FC<{ isCovered?: boolean; children: ReactNode; short?: boolean }> = ({
    isCovered,
    children,
    short
}) => (isCovered ? <div className={cn('material-rating', { extended: !short })}>{children}</div> : <>{children}</>);

export type MaterialRatingProps = {
    rating: number;
    emptyColor?: string;
    fillColor?: string;
    label?: string;
    short?: boolean;
    size?: number;
    voices?: number;
    isCovered?: boolean;
    noText?: boolean;
    withDecimals?: boolean;
    noNumbers?: boolean;
};

const MaterialRating: FC<MaterialRatingProps & TranslationProps> = (props) => {
    const {
        emptyColor = '#FFFFFF',
        fillColor = '#26BFBF',
        rating,
        label,
        short = false,
        isCovered = true,
        size = 24,
        voices = 0,
        t,
        noText = false,
        withDecimals = false,
        noNumbers = false
    } = props;
    const ratingVoices = label ?? `(${short || noText ? voices : t('feedbacks.feedbacksCount', { count: voices })})`;

    const averageRating = withDecimals ? rating.toFixed(1) : rating;

    return (
        <RatingContainer short={short} isCovered={isCovered}>
            <StarRating
                maxValue={short ? 1 : 5}
                ratingValue={short ? 1 : rating}
                fillColor={fillColor}
                emptyColor={short ? undefined : emptyColor}
                width={size}
                height={size}
                readOnly
            />
            {!noNumbers && (
                <>
                    <span className='average-rating-value'>{averageRating}</span>
                    <span className='total-rating-voices'>{ratingVoices}</span>
                </>
            )}
        </RatingContainer>
    );
};

const translate = translation('material-feedbacks');

export default translate(MaterialRating);
